import { z } from 'zod';
import { CadObjectSchema } from './cad-object.model';

export enum CadFileProcessingStatus {
  QUEUED = 'queued',
  EXTRACTING = 'extracting',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  PARTIAL_FAILURE = 'partial_failure',
  FAILED = 'failed',
}

export const CadFileProcessingUpdateSchema = z.object({
  id: z.number(),
  processing_status: z.enum([
    CadFileProcessingStatus.QUEUED,
    CadFileProcessingStatus.EXTRACTING,
    CadFileProcessingStatus.PROCESSING,
    CadFileProcessingStatus.COMPLETED,
    CadFileProcessingStatus.PARTIAL_FAILURE,
    CadFileProcessingStatus.FAILED,
  ]),
  processing_error: z.string().nullable(),
  total_object_count: z.number(),
  completed_object_count: z.number(),
  failed_object_count: z.number(),
});

export type CadFileProcessingUpdate = z.infer<
  typeof CadFileProcessingUpdateSchema
>;

export const CadFileSchema = z.object({
  id: z.number(),
  file: z.string(),
  filename: z.string(),
  owner: z.string(),
  company: z.number().nullable(),
  processing_status: CadFileProcessingUpdateSchema.shape.processing_status,
  processing_error: z.string(),
  total_object_count: z.number(),
  completed_object_count: z.number(),
  failed_object_count: z.number(),
  created_date: z.string(),
  cad_objects: z.array(CadObjectSchema),
});

export type CadFile = z.infer<typeof CadFileSchema>;

export const CAD_UPLOAD_EXTENSIONS = [
  '.step',
  '.stp',
  '.iges',
  '.igs',
] as const;

export const CAD_UPLOAD_ACCEPT = CAD_UPLOAD_EXTENSIONS.join(',');

export const CAD_UPLOAD_EXTENSIONS_LABEL = CAD_UPLOAD_EXTENSIONS.join(', ');

export function isCadUploadFile(file: File): boolean {
  const fileName = file.name.toLowerCase();
  return CAD_UPLOAD_EXTENSIONS.some((ext) => fileName.endsWith(ext));
}

export function cadUploadFileTypeError(fileNames: string[]): string {
  return `Invalid file type(s): ${fileNames.join(', ')}. Supported formats: ${CAD_UPLOAD_EXTENSIONS_LABEL}.`;
}
